import FounderProfile from '@src/pages/members/profile/[memberSlug]'

export { getServerSideProps } from '@src/lib/server-side-rendering'

export default FounderProfile
